(function() {
	'use strict';

	/**
	 * @ngdoc object
	 *
	 * @author maduka
	 * @description
	 *
	 */
	angular
		.module('paxMessageConfig')
		.directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() : $element[0].blur();
						});
					});
				}
			}
		})
		.controller('PaxMessageConfigCtrl',PaxMessageConfigCtrl);

	function PaxMessageConfigCtrl(applicationConstants, CommonMasterData,
			MessageService, EventManagerService, PaxMessageConfigService,
			AirportService, PopupManager, PaxMessageConfigFactory) {

		var vm = this;
		vm.ctrlName = 'PaxMessageConfigCtrl';

		vm.model = {
			searchOnGoing : false,
			searchPanelToggle : true,
			initialSearchDone : false,
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			searchCriteria : {
				countryCode : null
			},
			masterList : {
				countries : [],
				msgTypes : [],
				msgFields : [],
				triggers : [],
				apisVersions : []
			},
			paxMsgList : [],
			selectedFlifgtNo : null,
			isElasticLoadingVisible : false,
			showBottomPanel : false,
			sltdRow : [],
			editorRow : [],
			submited : false,
			fieldsList : [],
			triggerList : []
		};

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		vm.searchByOptions = function(searchParams) {
			search();
		};

		vm.clickOnBottomPanelView = function() {
			vm.model.showBottomPanel = !vm.model.showBottomPanel;
		}

		vm.selectFlRow = function(selectedRowData) {
			vm.model.showBottomPanel = true;
			vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
			vm.model.editorRow = PaxMessageConfigService.setEditorData(selectedRowData);
			vm.model.fieldsList = vm.model.editorRow.paxMsgFields;
			vm.model.triggerList = vm.model.editorRow.triggers;
		};

		function search() {
			PaxMessageConfigService.setSearchCriteria(vm.model.searchCriteria);
			PaxMessageConfigService.getPaxMessagesConfig(function(paxMsgList) {
				updateList(paxMsgList);
				vm.model.searchPanelToggle = false;
				vm.model.searchOnGoing = false;
			}, function(error) {
				MessageService.error(error);
			});
		}

		 function updateList(paxMsgList) {
			 vm.model.paxMsgList = [];
	            angular.forEach(paxMsgList, function (msg) {
	            	vm.model.paxMsgList.push(msg);
	            });
	            vm.model.isElasticLoadingVisible = false;
	        }

		vm.clickOnAdd = function() {
			vm.model.showBottomPanel = true;
			vm.model.editorRow = PaxMessageConfigFactory.getSaveRequest();
			vm.model.editorRow.paxMsgTypeId = 1;
			vm.model.editorRow.paxMsgApisVersion = "2011";
			vm.model.editorRow.inactive = false;
			vm.model.fieldsList = [];
			vm.model.triggerList=[];

		}

		vm.editClick = function(flag, data) {
			if (flag === 'delete') {
				vm.model.editorRow = PaxMessageConfigFactory.getSaveRequest();
				vm.model.editorRow.paxMsgTypeId = 1;
        vm.model.editorRow.paxMsgApisVersion = "2011";
				vm.model.editorRow.inactive = false;
				vm.model.fieldsList = [];
				vm.model.triggerList=[];
			} else {
				setFieldIds();
				setTriggerIds();
				save();
			}
		}

		vm.changeEditorField = function(flag, item) {
			if (flag === 'checkSelect') {
				vm.model.editorRow.paxMsgTypeId = item.paxMsgTypeId;
			}else if(flag === 'delete'){
				vm.model.editorRow = PaxMessageConfigFactory.getSaveRequest();
				vm.model.editorRow.paxMsgTypeId = 1;
        vm.model.editorMode.paxMsgApisVersion = '2011';
				vm.model.editorRow.inactive = false;
				vm.model.fieldsList = [];
				vm.model.triggerList=[];

			}else if (flag === 'checkSelect2') {
				vm.model.editorRow.paxMsgApisVersion = item;
			}
		}

		function save() {
			PaxMessageConfigService.setSaveData(vm.model.editorRow);
			PaxMessageConfigService.savePaxMessagesConfig(function() {
				vm.model.searchPanelToggle = false;
				MessageService.success('Successfully Saved!!');
				vm.model.showBottomPanel = false;
				vm.model.editorRow = PaxMessageConfigFactory.getSaveRequest();
				search();
			}, function(error) {
				MessageService.error(error);
			});

		}

		function setFieldIds() {
			var newFields = vm.model.editorRow.paxMsgFields;
			var fields = [];
			angular.forEach(newFields,function(field) {
					angular.forEach(vm.model.fieldsList,
						function(oldField) {
					if (oldField.fieldName === field.fieldName) {
						field.paxMsgCountryAvailFieldId = oldField.paxMsgCountryAvailFieldId;
					}});
						fields.push(field);
					});
			vm.model.editorRow.paxMsgFields = fields;
		}

		function setTriggerIds() {
			var newTriggers = vm.model.editorRow.triggers;
			var triggers = [];
			angular.forEach(newTriggers, function(trig) {
				angular.forEach(vm.model.triggerList, function(oldtrigger) {
					if (oldtrigger.hourBefore === trig.hourBefore) {
						trig.paxMsgTriggerId = oldtrigger.paxMsgTriggerId;
					}
				});

				triggers.push(trig);
			});
			vm.model.editorRow.triggers = triggers;

		}

		AirportService.searchCountries(function(countries) {
			vm.model.masterList.countries = countries;
		}, function(error) {
			MessageService.error(error);
		});

		PaxMessageConfigService.getPaxMessageTypes(function(types) {
			vm.model.masterList.msgTypes = types;
		}, function(error) {
			MessageService.error(error);
		});

		PaxMessageConfigService.getPaxMessageFields(function(fields) {
			vm.model.masterList.msgFields = fields;
		}, function(error) {
			MessageService.error(error);
		});

		PaxMessageConfigService.getPaxMessageTriggers(function(trigger) {
			vm.model.masterList.triggers = trigger;
		}, function(error) {
			MessageService.error(error);
		});

    PaxMessageConfigService.getPaxMessageApisVersions(function(versions) {
      vm.model.masterList.apisVersions = versions;
    }, function(error) {
      MessageService.error(error);
    });

	}
}());
